export default __webpack_public_path__ + "static/media/ico-material-black.3662a0f0.svg";